import { useEffect } from 'react';
import { useSiteStore } from '@/store/site';
import { useAccountInfo } from '@/hooks/query/account';
import { OneDomainService } from '@/services/onedomain.service';
import { useGetSiteConfigsWithSession } from '@/hooks/query/use-site-configs';
import { extractOneDomain } from '@nf/utils-common/url';
import { siteService } from '@/services/site.service';

export const OneDomainProvider = () => {
	const { user } = useAccountInfo();
	const [setApiDomain] = useSiteStore(state => [state.setApiDomain]);
	const { SiteConfigsWithSessionData } = useGetSiteConfigsWithSession();

	useEffect(() => {
		const accountStatus = user?.ActStatus ?? 0;

		const { protocol, hostname } = location; 

		const finalProtocol = process.env.NODE_ENV === 'development' ? 'https:' : protocol;

		const firstDotIndex = hostname.indexOf('.');

		if (firstDotIndex > -1) {
			const oneDomainForWeb = hostname.slice(0, firstDotIndex);
			const [webFunctionId] = extractOneDomain(oneDomainForWeb);
			const enableMainDomainOnPremise = (SiteConfigsWithSessionData?.MainDomainOnPremise ?? '') != '';
			const mainDomain = ['gc', 'go', 'gd'].indexOf(webFunctionId) != -1 && enableMainDomainOnPremise ? SiteConfigsWithSessionData?.MainDomainOnPremise : hostname.slice(firstDotIndex + 1);
			const oneDomainForApi = OneDomainService.getOneDomainForApi(oneDomainForWeb, accountStatus, enableMainDomainOnPremise);

			setApiDomain(`${finalProtocol}//${oneDomainForApi}.${mainDomain}`);
		} else {
			setApiDomain(`${finalProtocol}//${siteService.getDevApiSubdomain()}.kl5888.com`);
		}
	}, [user?.ActStatus, SiteConfigsWithSessionData?.MainDomainOnPremise]);
	return null;
};